<template>
  <div class="setting-header">
    <i class="el-icon-menu"></i>
    <el-select
      v-model="selectedProjectId"
      filterable
      placeholder="请选择应用"
      @change="handleAppSelect"
      :filter-method="handleFilter"
      @visible-change="v=>filteredAppList = appList"
    >
      <el-option
        v-for="item in filteredAppList"
        :key="item.projectId"
        :label="`${item.projectName}(${item.projectId})`"
        :value="item.projectId"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "AppSelect",
  data() {
    return {
      fetching: false,
      selectedProjectId: "",
      appList: [],
      filteredAppList: [],
    };
  },
  created() {
    this.getAppList();
  },
  methods: {
    // 前端过滤
    handleFilter(val) {
      const searchVal = (val || "").trim().toLocaleLowerCase();
      if (!searchVal) {
        this.filteredAppList = this.appList;
        return;
      }
      this.filteredAppList = this.appList.filter(
        (it) =>
          it.projectId.toLocaleLowerCase().indexOf(searchVal) > -1 ||
          it.projectName.toLocaleLowerCase().indexOf(searchVal) > -1 
      );
    },
    /** 应用 */
    async getAppList() {
      this.$store
        .dispatch("httpGet", {
          curl:  "/application/list",
        })
        .then((res) => {
          this.appList = res.data
          this.filteredAppList = res.data
          if (
            this.$store.getters.appId &&
            this.appList.some(
              (it) => it.projectId === this.$store.getters.appId
            )
          ) {
            this.selectedProjectId = this.$store.getters.appId;
          } else {
            this.selectedProjectId = this.appList[0].projectId
            this.$store.commit("getAppId", this.selectedProjectId)
          }
        });
    },
    // 切换应用
    handleAppSelect(value) {
      this.$store.commit("getAppId", value)
    },
  },
};
</script>

<style lang="scss" scoped>
.setting-header {
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding-left: 16px;
  margin-bottom: 0;
}
/deep/ .el-select {
  min-width: 130px;
  max-width: 225px;
  margin-left: 4px;
  .el-input__inner {
    border-color: #ffffff;
    &:hover,
    &:focus {
      border-color: #409eff;
    }
  }
  .el-input__icon {
    line-height: 2rem;
  }
}
</style>
